import React from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { rrss } from "../data/links";
import suitsData from "../data/suits.json";

export default function SuitPage() {
  const suitEntries = Object.entries(suitsData)
  .filter(([key]) => key !== "joker");

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Palos | ERI</title>
        </Helmet>
      </HelmetProvider>
      <div id="suit" className="content">
        <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Palos</h1>
          <p className="subtitle">
            En nuestro <a className="social-url dc" title="Discord" href={rrss.dc} target="_blank" rel="noopener noreferrer">servidor de Discord</a> los miembros se dividen en los palos de la baraja y cada uno de ellos tiene unas características únicas.
          </p>
          <p className="subtitle">¿Quieres descubrir con cuál te identificas?</p>
        </div>
        <div className="content-main">
          <div className="content-items">
            {suitEntries.map(([key, suit]) => (
              <div key={key} id={suit.id} className="suit-card separator-down">
                <h2 className="suit-name">{suit.title}</h2>
                <img  className="suit-img" src={`${process.env.PUBLIC_URL}/img/suit/suit-normal-${suit.id}.png`} alt={suit.title}/>
                <Link className="btn btn-primary" to={`/palos/${key}`}>Ver más</Link>
              </div>
            ))}
          </div>
        </div>
        
        <Link className="btn btn-primary test" to={`/test-palos`}>Hacer el test</Link>

        </div>
      </div>
    </>
  );
}
